import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  items: function items(state) {
    return state.items;
  },
  products: function products(state) {
    return state.products;
  }
};